[
	{
		"artsuch": "Schiene",
		"betaufnr": 128001,
		"kdnr": 12346,
		"artnr": "5123437",
		"Analysis_No": "128001",
		"Parts_on_Filter": 6.0,
		"Component_Surface_Area_cm2": 186.0,
		"Weight_mg": 0.45,
		"Date_of_arrival": "2021-08-01T15:00:00",
		"Date_of_Extraction": "2021-08-01T15:00:00",
		"Date_of_Analysis": "2021-08-01T15:00:00",
		"Component": "Schiene",
		"Component_No": "XYZ",
		"Testing_Specification": "5123437",
		"customer_no": "12346",
		"Place_of_probe": "nicht bekannt / unknown",
		"Condition_of_delivery": "i. O.",
		"Extraction_Method": null,
		"Extraction_Liquid": null,
		"Amount_Liquid": null,
		"volume_flow": null,
		"nozzle_dimension": null,
		"amount_flushing": null,
		"extraction_equipment": null,
		"Filter_Type": null,
		"filter_diameter": "47 mm",
		"Comment": null,
		"Scale": "X:5,4 μm/Pxl   Y:5,4 μm/Pxl",
		"Evaluated_diameter_mm": 44.0,
		"occupancy": 1.172178,
		"Fiber_Compactness_Criterion": null,
		"Fiber_Length_Width_Criterion": null,
		"Fiber_Stret_InCircle_criterion": 10.0,
		"Fiber_max_InCircle_criterion": 50.0,
		"woF_5_15": 25165.0,
		"woF_15_25": 17685.0,
		"woF_25_50": 6792.0,
		"woF_50_100": 1346.0,
		"woF_100_150": 150.0,
		"woF_150_200": 34.0,
		"woF_200_400": 21.0,
		"woF_400_600": 2.0,
		"woF_600_1000": 0.0,
		"woF_gt_1000": 0.0,
		"woF_200_300": 2.0,
		"woF_300_400": 0.0,
		"woF_400_500": null,
		"woF_500_600": 1.0,
		"woF_600_700": 0.0,
		"woF_700_800": 0.0,
		"woF_800_900": 0.0,
		"woF_900_1000": 0.0,
		"woF_1000_1500": 0.0,
		"woF_1500_2000": 0.0,
		"woF_2000_2500": 0.0,
		"woF_2500_3000": 0.0,
		"woF_gt_3000": 0.0,
		"All_5_15": 25165.0,
		"All_15_25": 17685.0,
		"All_25_50": 6792.0,
		"All_50_100": 1373.0,
		"All_100_150": 194.0,
		"All_150_200": 57.0,
		"All_200_400": 67.0,
		"All_400_600": 16.0,
		"All_600_1000": 21.0,
		"All_gt_1000": 7.0,
		"All_200_300": 44.0,
		"All_300_400": 28.0,
		"All_400_500": null,
		"All_500_600": 6.0,
		"All_600_700": 6.0,
		"All_700_800": 6.0,
		"All_800_900": 5.0,
		"All_900_1000": 4.0,
		"All_1000_1500": 2.0,
		"All_1500_2000": 1.0,
		"All_2000_2500": 1.0,
		"All_2500_3000": 1.0,
		"All_gt_3000": 2.0,
		"Met_5_15": 3.0,
		"Met_15_25": 8.0,
		"Met_25_50": 5.0,
		"Met_50_100": 6.0,
		"Met_100_150": 0.0,
		"Met_150_200": 0.0,
		"Met_200_400": 0.0,
		"Met_400_600": 0.0,
		"Met_600_1000": 0.0,
		"Met_gt_1000": 0.0,
		"Met_200_300": 0.0,
		"Met_300_400": 0.0,
		"Met_400_500": null,
		"Met_500_600": 0.0,
		"Met_600_700": 0.0,
		"Met_700_800": 0.0,
		"Met_800_900": 0.0,
		"Met_900_1000": 0.0,
		"Met_1000_1500": 0.0,
		"Met_1500_2000": 0.0,
		"Met_2000_2500": 0.0,
		"Met_2500_3000": 0.0,
		"Met_gt_3000": 0.0,
		"woFNM_1L": 516.0,
		"woFNM_1W": 297.0,
		"woFNM_2L": 449.0,
		"woFNM_2W": 341.0,
		"woFNM_3L": 355.0,
		"woFNM_3W": 162.0,
		"woFNM_4L": 328.0,
		"woFNM_4W": 77.0,
		"woFNM_5L": 299.0,
		"woFNM_5W": 86.0,
		"Met_1L": 83.0,
		"Met_1W": 43.0,
		"Met_2L": 71.0,
		"Met_2W": 45.0,
		"Met_3L": 66.0,
		"Met_3W": 27.0,
		"Met_4L": 65.0,
		"Met_4W": 32.0,
		"Met_5L": 51.0,
		"Met_5W": 38.0,
		"Fib_Fmax1_Fmax": 3608.0,
		"Fib_Fmax1_Lstr": 5668.0,
		"Fib_Fmax2_Fmax": 3320.0,
		"Fib_Fmax2_Lstr": 5859.0,
		"Fib_Lstr1_Fmax": 3320.0,
		"Fib_Lstr1_Lstr": 5859.0,
		"Fib_Fmax_Sum_um": 64473.0,
		"Fib_Stretched_Sum_um": 78873.0,
		"woF_weighted_sum": 2716.0,
		"All_weighted_sum": 10582.0,
		"Met_weighted_sum": 6.0,
		"Fib_strlength_5_15": null,
		"Fib_strlength_15_25": null,
		"Fib_strlength_25_50": null,
		"Fib_strlength_50_100": null,
		"Fib_strlength_100_150": null,
		"Fib_strlength_150_200": null,
		"Fib_strlength_200_400": null,
		"Fib_strlength_400_600": null,
		"Fib_strlength_600_1000": null,
		"Fib_strlength_gt_1000": null,
		"Fib_strlength_200_300": null,
		"Fib_strlength_300_400": null,
		"Fib_strlength_400_500": null,
		"Fib_strlength_500_600": null,
		"Fib_strlength_600_700": null,
		"Fib_strlength_700_800": null,
		"Fib_strlength_800_900": null,
		"Fib_strlength_900_1000": null,
		"Fib_strlength_1000_1500": null,
		"Fib_strlength_1500_2000": null,
		"Fib_strlength_2000_2500": null,
		"Fib_strlength_2500_3000": null,
		"Fib_strlength_gt_3000": null,
		"analysis_int": 128001,
		"Passed": null,
		"zeichnr": "Schiene",
		"met_sum": 6.0,
		"nm_sum": 1547.0,
		"sum_fibers": 181.0,
		"fibers_sum": 181.0,
		"smallest_size_class": "50-100",
		"ioResult": true,
		"zeichindex": "1234"
	},
	{
		"artsuch": "Schiene",
		"betaufnr": 128002,
		"kdnr": 12346,
		"artnr": "5123437",
		"Analysis_No": "128002",
		"Parts_on_Filter": 6.0,
		"Component_Surface_Area_cm2": 186.0,
		"Weight_mg": 0.27,
		"Date_of_arrival": "2021-08-02T15:00:00",
		"Date_of_Extraction": "2021-08-02T15:00:00",
		"Date_of_Analysis": "2021-08-02T15:00:00",
		"Component": "Schiene",
		"Component_No": "XYZ",
		"Testing_Specification": "5123437",
		"customer_no": "12346",
		"Place_of_probe": "nicht bekannt / unknown",
		"Condition_of_delivery": "i. O.",
		"Extraction_Method": null,
		"Extraction_Liquid": null,
		"Amount_Liquid": null,
		"volume_flow": null,
		"nozzle_dimension": null,
		"amount_flushing": null,
		"extraction_equipment": null,
		"Filter_Type": null,
		"filter_diameter": "47 mm",
		"Comment": null,
		"Scale": "X:5,4 μm/Pxl   Y:5,4 μm/Pxl",
		"Evaluated_diameter_mm": 44.0,
		"occupancy": 0.664124,
		"Fiber_Compactness_Criterion": null,
		"Fiber_Length_Width_Criterion": null,
		"Fiber_Stret_InCircle_criterion": 10.0,
		"Fiber_max_InCircle_criterion": 50.0,
		"woF_5_15": 12482.0,
		"woF_15_25": 8576.0,
		"woF_25_50": 3905.0,
		"woF_50_100": 891.0,
		"woF_100_150": 120.0,
		"woF_150_200": 28.0,
		"woF_200_400": 10.0,
		"woF_400_600": 2.0,
		"woF_600_1000": 2.0,
		"woF_gt_1000": 0.0,
		"woF_200_300": 4.0,
		"woF_300_400": 2.0,
		"woF_400_500": null,
		"woF_500_600": 1.0,
		"woF_600_700": 0.0,
		"woF_700_800": 1.0,
		"woF_800_900": 1.0,
		"woF_900_1000": 0.0,
		"woF_1000_1500": 0.0,
		"woF_1500_2000": 0.0,
		"woF_2000_2500": 0.0,
		"woF_2500_3000": 0.0,
		"woF_gt_3000": 0.0,
		"All_5_15": 12482.0,
		"All_15_25": 8576.0,
		"All_25_50": 3905.0,
		"All_50_100": 902.0,
		"All_100_150": 144.0,
		"All_150_200": 49.0,
		"All_200_400": 75.0,
		"All_400_600": 18.0,
		"All_600_1000": 9.0,
		"All_gt_1000": 11.0,
		"All_200_300": 38.0,
		"All_300_400": 20.0,
		"All_400_500": null,
		"All_500_600": 9.0,
		"All_600_700": 1.0,
		"All_700_800": 1.0,
		"All_800_900": 3.0,
		"All_900_1000": 4.0,
		"All_1000_1500": 7.0,
		"All_1500_2000": 1.0,
		"All_2000_2500": 2.0,
		"All_2500_3000": 0.0,
		"All_gt_3000": 1.0,
		"Met_5_15": 1.0,
		"Met_15_25": 4.0,
		"Met_25_50": 8.0,
		"Met_50_100": 3.0,
		"Met_100_150": 0.0,
		"Met_150_200": 0.0,
		"Met_200_400": 0.0,
		"Met_400_600": 0.0,
		"Met_600_1000": 0.0,
		"Met_gt_1000": 0.0,
		"Met_200_300": 0.0,
		"Met_300_400": 0.0,
		"Met_400_500": null,
		"Met_500_600": 0.0,
		"Met_600_700": 0.0,
		"Met_700_800": 0.0,
		"Met_800_900": 0.0,
		"Met_900_1000": 0.0,
		"Met_1000_1500": 0.0,
		"Met_1500_2000": 0.0,
		"Met_2000_2500": 0.0,
		"Met_2500_3000": 0.0,
		"Met_gt_3000": 0.0,
		"woFNM_1L": 813.0,
		"woFNM_1W": 286.0,
		"woFNM_2L": 786.0,
		"woFNM_2W": 103.0,
		"woFNM_3L": 567.0,
		"woFNM_3W": 127.0,
		"woFNM_4L": 419.0,
		"woFNM_4W": 82.0,
		"woFNM_5L": 352.0,
		"woFNM_5W": 227.0,
		"Met_1L": 96.0,
		"Met_1W": 76.0,
		"Met_2L": 96.0,
		"Met_2W": 69.0,
		"Met_3L": 80.0,
		"Met_3W": 43.0,
		"Met_4L": 48.0,
		"Met_4W": 22.0,
		"Met_5L": 44.0,
		"Met_5W": 12.0,
		"Fib_Fmax1_Fmax": 3440.0,
		"Fib_Fmax1_Lstr": 3942.0,
		"Fib_Fmax2_Fmax": 2085.0,
		"Fib_Fmax2_Lstr": 2360.0,
		"Fib_Lstr1_Fmax": 3440.0,
		"Fib_Lstr1_Lstr": 3942.0,
		"Fib_Fmax_Sum_um": 57470.0,
		"Fib_Stretched_Sum_um": 72529.0,
		"woF_weighted_sum": 2199.0,
		"All_weighted_sum": 9967.0,
		"Met_weighted_sum": 3.0,
		"Fib_strlength_5_15": null,
		"Fib_strlength_15_25": null,
		"Fib_strlength_25_50": null,
		"Fib_strlength_50_100": null,
		"Fib_strlength_100_150": null,
		"Fib_strlength_150_200": null,
		"Fib_strlength_200_400": null,
		"Fib_strlength_400_600": null,
		"Fib_strlength_600_1000": null,
		"Fib_strlength_gt_1000": null,
		"Fib_strlength_200_300": null,
		"Fib_strlength_300_400": null,
		"Fib_strlength_400_500": null,
		"Fib_strlength_500_600": null,
		"Fib_strlength_600_700": null,
		"Fib_strlength_700_800": null,
		"Fib_strlength_800_900": null,
		"Fib_strlength_900_1000": null,
		"Fib_strlength_1000_1500": null,
		"Fib_strlength_1500_2000": null,
		"Fib_strlength_2000_2500": null,
		"Fib_strlength_2500_3000": null,
		"Fib_strlength_gt_3000": null,
		"analysis_int": 128002,
		"Passed": "0",
		"zeichnr": "Schiene",
		"met_sum": 3.0,
		"nm_sum": 1050.0,
		"sum_fibers": 153.0,
		"fibers_sum": 153.0,
		"smallest_size_class": "50-100",
		"ioResult": true,
		"zeichindex": "1234"
	},
	{
		"artsuch": "Schiene",
		"betaufnr": 128003,
		"kdnr": 12346,
		"artnr": "5123437",
		"Analysis_No": "128003",
		"Parts_on_Filter": 6.0,
		"Component_Surface_Area_cm2": 186.0,
		"Weight_mg": 0.48,
		"Date_of_arrival": "2021-08-03T15:00:00",
		"Date_of_Extraction": "2021-08-03T15:00:00",
		"Date_of_Analysis": "2021-08-03T15:00:00",
		"Component": "Schiene",
		"Component_No": "XYZ",
		"Testing_Specification": "5123437",
		"customer_no": "12346",
		"Place_of_probe": "nicht bekannt / unknown",
		"Condition_of_delivery": "i. O.",
		"Extraction_Method": null,
		"Extraction_Liquid": null,
		"Amount_Liquid": null,
		"volume_flow": null,
		"nozzle_dimension": null,
		"amount_flushing": null,
		"extraction_equipment": null,
		"Filter_Type": null,
		"filter_diameter": "47 mm",
		"Comment": null,
		"Scale": "X:5,4 μm/Pxl   Y:5,4 μm/Pxl",
		"Evaluated_diameter_mm": 44.0,
		"occupancy": 0.978444,
		"Fiber_Compactness_Criterion": null,
		"Fiber_Length_Width_Criterion": null,
		"Fiber_Stret_InCircle_criterion": 10.0,
		"Fiber_max_InCircle_criterion": 50.0,
		"woF_5_15": 15867.0,
		"woF_15_25": 11286.0,
		"woF_25_50": 5601.0,
		"woF_50_100": 1218.0,
		"woF_100_150": 159.0,
		"woF_150_200": 40.0,
		"woF_200_400": 26.0,
		"woF_400_600": 1.0,
		"woF_600_1000": 1.0,
		"woF_gt_1000": 1.0,
		"woF_200_300": 3.0,
		"woF_300_400": 2.0,
		"woF_400_500": null,
		"woF_500_600": 0.0,
		"woF_600_700": 0.0,
		"woF_700_800": 0.0,
		"woF_800_900": 1.0,
		"woF_900_1000": 0.0,
		"woF_1000_1500": 1.0,
		"woF_1500_2000": 0.0,
		"woF_2000_2500": 0.0,
		"woF_2500_3000": 0.0,
		"woF_gt_3000": 0.0,
		"All_5_15": 15867.0,
		"All_15_25": 11286.0,
		"All_25_50": 5601.0,
		"All_50_100": 1240.0,
		"All_100_150": 212.0,
		"All_150_200": 78.0,
		"All_200_400": 110.0,
		"All_400_600": 35.0,
		"All_600_1000": 28.0,
		"All_gt_1000": 21.0,
		"All_200_300": 84.0,
		"All_300_400": 49.0,
		"All_400_500": null,
		"All_500_600": 16.0,
		"All_600_700": 8.0,
		"All_700_800": 8.0,
		"All_800_900": 6.0,
		"All_900_1000": 6.0,
		"All_1000_1500": 12.0,
		"All_1500_2000": 6.0,
		"All_2000_2500": 2.0,
		"All_2500_3000": 1.0,
		"All_gt_3000": 0.0,
		"Met_5_15": 3.0,
		"Met_15_25": 11.0,
		"Met_25_50": 24.0,
		"Met_50_100": 11.0,
		"Met_100_150": 2.0,
		"Met_150_200": 0.0,
		"Met_200_400": 0.0,
		"Met_400_600": 0.0,
		"Met_600_1000": 0.0,
		"Met_gt_1000": 0.0,
		"Met_200_300": 0.0,
		"Met_300_400": 0.0,
		"Met_400_500": null,
		"Met_500_600": 0.0,
		"Met_600_700": 0.0,
		"Met_700_800": 0.0,
		"Met_800_900": 0.0,
		"Met_900_1000": 0.0,
		"Met_1000_1500": 0.0,
		"Met_1500_2000": 0.0,
		"Met_2000_2500": 0.0,
		"Met_2500_3000": 0.0,
		"Met_gt_3000": 0.0,
		"woFNM_1L": 1132.0,
		"woFNM_1W": 541.0,
		"woFNM_2L": 843.0,
		"woFNM_2W": 578.0,
		"woFNM_3L": 420.0,
		"woFNM_3W": 178.0,
		"woFNM_4L": 386.0,
		"woFNM_4W": 65.0,
		"woFNM_5L": 332.0,
		"woFNM_5W": 222.0,
		"Met_1L": 124.0,
		"Met_1W": 70.0,
		"Met_2L": 112.0,
		"Met_2W": 65.0,
		"Met_3L": 96.0,
		"Met_3W": 38.0,
		"Met_4L": 96.0,
		"Met_4W": 53.0,
		"Met_5L": 71.0,
		"Met_5W": 54.0,
		"Fib_Fmax1_Fmax": 2569.0,
		"Fib_Fmax1_Lstr": 3760.0,
		"Fib_Fmax2_Fmax": 2073.0,
		"Fib_Fmax2_Lstr": 2358.0,
		"Fib_Lstr1_Fmax": 2569.0,
		"Fib_Lstr1_Lstr": 3760.0,
		"Fib_Fmax_Sum_um": 106520.0,
		"Fib_Stretched_Sum_um": 125324.0,
		"woF_weighted_sum": 3238.0,
		"All_weighted_sum": 19222.0,
		"Met_weighted_sum": 19.0,
		"Fib_strlength_5_15": null,
		"Fib_strlength_15_25": null,
		"Fib_strlength_25_50": null,
		"Fib_strlength_50_100": null,
		"Fib_strlength_100_150": null,
		"Fib_strlength_150_200": null,
		"Fib_strlength_200_400": null,
		"Fib_strlength_400_600": null,
		"Fib_strlength_600_1000": null,
		"Fib_strlength_gt_1000": null,
		"Fib_strlength_200_300": null,
		"Fib_strlength_300_400": null,
		"Fib_strlength_400_500": null,
		"Fib_strlength_500_600": null,
		"Fib_strlength_600_700": null,
		"Fib_strlength_700_800": null,
		"Fib_strlength_800_900": null,
		"Fib_strlength_900_1000": null,
		"Fib_strlength_1000_1500": null,
		"Fib_strlength_1500_2000": null,
		"Fib_strlength_2000_2500": null,
		"Fib_strlength_2500_3000": null,
		"Fib_strlength_gt_3000": null,
		"analysis_int": 128003,
		"Passed": "0",
		"zeichnr": "Schiene",
		"met_sum": 13.0,
		"nm_sum": 1433.0,
		"sum_fibers": 276.0,
		"fibers_sum": 276.0,
		"smallest_size_class": "50-100",
		"ioResult": true,
		"zeichindex": "1234"
	},
	{
		"artsuch": "Schiene",
		"betaufnr": 128004,
		"kdnr": 12346,
		"artnr": "5123437",
		"Analysis_No": "128004",
		"Parts_on_Filter": 6.0,
		"Component_Surface_Area_cm2": 186.0,
		"Weight_mg": 0.42,
		"Date_of_arrival": "2021-08-04T15:00:00",
		"Date_of_Extraction": "2021-08-04T15:00:00",
		"Date_of_Analysis": "2021-08-04T15:00:00",
		"Component": "Schiene",
		"Component_No": "XYZ",
		"Testing_Specification": "5123437",
		"customer_no": "12346",
		"Place_of_probe": "nicht bekannt / unknown",
		"Condition_of_delivery": "i. O.",
		"Extraction_Method": null,
		"Extraction_Liquid": null,
		"Amount_Liquid": null,
		"volume_flow": null,
		"nozzle_dimension": null,
		"amount_flushing": null,
		"extraction_equipment": null,
		"Filter_Type": null,
		"filter_diameter": "47 mm",
		"Comment": null,
		"Scale": "X:5,4 μm/Pxl   Y:5,4 μm/Pxl",
		"Evaluated_diameter_mm": 44.0,
		"occupancy": 0.980316,
		"Fiber_Compactness_Criterion": null,
		"Fiber_Length_Width_Criterion": null,
		"Fiber_Stret_InCircle_criterion": 10.0,
		"Fiber_max_InCircle_criterion": 50.0,
		"woF_5_15": 17241.0,
		"woF_15_25": 13748.0,
		"woF_25_50": 5966.0,
		"woF_50_100": 1206.0,
		"woF_100_150": 137.0,
		"woF_150_200": 35.0,
		"woF_200_400": 25.0,
		"woF_400_600": 2.0,
		"woF_600_1000": 1.0,
		"woF_gt_1000": 0.0,
		"woF_200_300": 3.0,
		"woF_300_400": 1.0,
		"woF_400_500": null,
		"woF_500_600": 0.0,
		"woF_600_700": 1.0,
		"woF_700_800": 0.0,
		"woF_800_900": 0.0,
		"woF_900_1000": 0.0,
		"woF_1000_1500": 0.0,
		"woF_1500_2000": 0.0,
		"woF_2000_2500": 0.0,
		"woF_2500_3000": 0.0,
		"woF_gt_3000": 0.0,
		"All_5_15": 17241.0,
		"All_15_25": 13748.0,
		"All_25_50": 5966.0,
		"All_50_100": 1226.0,
		"All_100_150": 173.0,
		"All_150_200": 66.0,
		"All_200_400": 92.0,
		"All_400_600": 25.0,
		"All_600_1000": 18.0,
		"All_gt_1000": 11.0,
		"All_200_300": 54.0,
		"All_300_400": 29.0,
		"All_400_500": null,
		"All_500_600": 6.0,
		"All_600_700": 10.0,
		"All_700_800": 4.0,
		"All_800_900": 2.0,
		"All_900_1000": 2.0,
		"All_1000_1500": 7.0,
		"All_1500_2000": 1.0,
		"All_2000_2500": 2.0,
		"All_2500_3000": 0.0,
		"All_gt_3000": 1.0,
		"Met_5_15": 0.0,
		"Met_15_25": 0.0,
		"Met_25_50": 4.0,
		"Met_50_100": 3.0,
		"Met_100_150": 0.0,
		"Met_150_200": 0.0,
		"Met_200_400": 0.0,
		"Met_400_600": 0.0,
		"Met_600_1000": 0.0,
		"Met_gt_1000": 0.0,
		"Met_200_300": 0.0,
		"Met_300_400": 0.0,
		"Met_400_500": null,
		"Met_500_600": 0.0,
		"Met_600_700": 0.0,
		"Met_700_800": 0.0,
		"Met_800_900": 0.0,
		"Met_900_1000": 0.0,
		"Met_1000_1500": 0.0,
		"Met_1500_2000": 0.0,
		"Met_2000_2500": 0.0,
		"Met_2500_3000": 0.0,
		"Met_gt_3000": 0.0,
		"woFNM_1L": 647.0,
		"woFNM_1W": 363.0,
		"woFNM_2L": 493.0,
		"woFNM_2W": 286.0,
		"woFNM_3L": 436.0,
		"woFNM_3W": 292.0,
		"woFNM_4L": 400.0,
		"woFNM_4W": 178.0,
		"woFNM_5L": 319.0,
		"woFNM_5W": 130.0,
		"Met_1L": 93.0,
		"Met_1W": 27.0,
		"Met_2L": 85.0,
		"Met_2W": 65.0,
		"Met_3L": 74.0,
		"Met_3W": 54.0,
		"Met_4L": 47.0,
		"Met_4W": 22.0,
		"Met_5L": 41.0,
		"Met_5W": 27.0,
		"Fib_Fmax1_Fmax": 3610.0,
		"Fib_Fmax1_Lstr": 5059.0,
		"Fib_Fmax2_Fmax": 2326.0,
		"Fib_Fmax2_Lstr": 2681.0,
		"Fib_Lstr1_Fmax": 3610.0,
		"Fib_Lstr1_Lstr": 5059.0,
		"Fib_Fmax_Sum_um": 71808.0,
		"Fib_Stretched_Sum_um": 86856.0,
		"woF_weighted_sum": 2741.0,
		"All_weighted_sum": 12576.0,
		"Met_weighted_sum": 3.0,
		"Fib_strlength_5_15": null,
		"Fib_strlength_15_25": null,
		"Fib_strlength_25_50": null,
		"Fib_strlength_50_100": null,
		"Fib_strlength_100_150": null,
		"Fib_strlength_150_200": null,
		"Fib_strlength_200_400": null,
		"Fib_strlength_400_600": null,
		"Fib_strlength_600_1000": null,
		"Fib_strlength_gt_1000": null,
		"Fib_strlength_200_300": null,
		"Fib_strlength_300_400": null,
		"Fib_strlength_400_500": null,
		"Fib_strlength_500_600": null,
		"Fib_strlength_600_700": null,
		"Fib_strlength_700_800": null,
		"Fib_strlength_800_900": null,
		"Fib_strlength_900_1000": null,
		"Fib_strlength_1000_1500": null,
		"Fib_strlength_1500_2000": null,
		"Fib_strlength_2000_2500": null,
		"Fib_strlength_2500_3000": null,
		"Fib_strlength_gt_3000": null,
		"analysis_int": 128004,
		"Passed": "0",
		"zeichnr": "Schiene",
		"met_sum": 3.0,
		"nm_sum": 1403.0,
		"sum_fibers": 203.0,
		"fibers_sum": 203.0,
		"smallest_size_class": "50-100",
		"ioResult": true,
		"zeichindex": "1234"
	},
	{
		"artsuch": "Schiene",
		"betaufnr": 128005,
		"kdnr": 12346,
		"artnr": "5123437",
		"Analysis_No": "128005",
		"Parts_on_Filter": 6.0,
		"Component_Surface_Area_cm2": 186.0,
		"Weight_mg": 0.34,
		"Date_of_arrival": "2021-08-05T15:00:00",
		"Date_of_Extraction": "2021-08-05T15:00:00",
		"Date_of_Analysis": "2021-08-05T15:00:00",
		"Component": "Schiene",
		"Component_No": "XYZ",
		"Testing_Specification": "5123437",
		"customer_no": "12346",
		"Place_of_probe": "nicht bekannt / unknown",
		"Condition_of_delivery": "i. O.",
		"Extraction_Method": null,
		"Extraction_Liquid": null,
		"Amount_Liquid": null,
		"volume_flow": null,
		"nozzle_dimension": null,
		"amount_flushing": null,
		"extraction_equipment": null,
		"Filter_Type": null,
		"filter_diameter": "47 mm",
		"Comment": null,
		"Scale": "X:5,4 μm/Pxl   Y:5,4 μm/Pxl",
		"Evaluated_diameter_mm": 44.0,
		"occupancy": 0.70345,
		"Fiber_Compactness_Criterion": null,
		"Fiber_Length_Width_Criterion": null,
		"Fiber_Stret_InCircle_criterion": 10.0,
		"Fiber_max_InCircle_criterion": 50.0,
		"woF_5_15": 11372.0,
		"woF_15_25": 8279.0,
		"woF_25_50": 3858.0,
		"woF_50_100": 847.0,
		"woF_100_150": 102.0,
		"woF_150_200": 29.0,
		"woF_200_400": 16.0,
		"woF_400_600": 2.0,
		"woF_600_1000": 4.0,
		"woF_gt_1000": 1.0,
		"woF_200_300": 7.0,
		"woF_300_400": 5.0,
		"woF_400_500": null,
		"woF_500_600": 1.0,
		"woF_600_700": 1.0,
		"woF_700_800": 3.0,
		"woF_800_900": 0.0,
		"woF_900_1000": 0.0,
		"woF_1000_1500": 1.0,
		"woF_1500_2000": 0.0,
		"woF_2000_2500": 0.0,
		"woF_2500_3000": 0.0,
		"woF_gt_3000": 0.0,
		"All_5_15": 11372.0,
		"All_15_25": 8279.0,
		"All_25_50": 3858.0,
		"All_50_100": 855.0,
		"All_100_150": 130.0,
		"All_150_200": 58.0,
		"All_200_400": 61.0,
		"All_400_600": 22.0,
		"All_600_1000": 12.0,
		"All_gt_1000": 14.0,
		"All_200_300": 48.0,
		"All_300_400": 26.0,
		"All_400_500": null,
		"All_500_600": 9.0,
		"All_600_700": 5.0,
		"All_700_800": 4.0,
		"All_800_900": 3.0,
		"All_900_1000": 0.0,
		"All_1000_1500": 6.0,
		"All_1500_2000": 5.0,
		"All_2000_2500": 2.0,
		"All_2500_3000": 0.0,
		"All_gt_3000": 1.0,
		"Met_5_15": 0.0,
		"Met_15_25": 3.0,
		"Met_25_50": 3.0,
		"Met_50_100": 0.0,
		"Met_100_150": 1.0,
		"Met_150_200": 1.0,
		"Met_200_400": 0.0,
		"Met_400_600": 1.0,
		"Met_600_1000": 0.0,
		"Met_gt_1000": 0.0,
		"Met_200_300": 1.0,
		"Met_300_400": 0.0,
		"Met_400_500": null,
		"Met_500_600": 0.0,
		"Met_600_700": 0.0,
		"Met_700_800": 0.0,
		"Met_800_900": 0.0,
		"Met_900_1000": 0.0,
		"Met_1000_1500": 0.0,
		"Met_1500_2000": 0.0,
		"Met_2000_2500": 0.0,
		"Met_2500_3000": 0.0,
		"Met_gt_3000": 0.0,
		"woFNM_1L": 1130.0,
		"woFNM_1W": 578.0,
		"woFNM_2L": 796.0,
		"woFNM_2W": 433.0,
		"woFNM_3L": 761.0,
		"woFNM_3W": 535.0,
		"woFNM_4L": 738.0,
		"woFNM_4W": 476.0,
		"woFNM_5L": 663.0,
		"woFNM_5W": 124.0,
		"Met_1L": 429.0,
		"Met_1W": 211.0,
		"Met_2L": 170.0,
		"Met_2W": 59.0,
		"Met_3L": 138.0,
		"Met_3W": 54.0,
		"Met_4L": 32.0,
		"Met_4W": 15.0,
		"Met_5L": 29.0,
		"Met_5W": 16.0,
		"Fib_Fmax1_Fmax": 3504.0,
		"Fib_Fmax1_Lstr": 4278.0,
		"Fib_Fmax2_Fmax": 2154.0,
		"Fib_Fmax2_Lstr": 2638.0,
		"Fib_Lstr1_Fmax": 3504.0,
		"Fib_Lstr1_Lstr": 4278.0,
		"Fib_Fmax_Sum_um": 59625.0,
		"Fib_Stretched_Sum_um": 70542.0,
		"woF_weighted_sum": 2876.0,
		"All_weighted_sum": 11609.0,
		"Met_weighted_sum": 77.0,
		"Fib_strlength_5_15": null,
		"Fib_strlength_15_25": null,
		"Fib_strlength_25_50": null,
		"Fib_strlength_50_100": null,
		"Fib_strlength_100_150": null,
		"Fib_strlength_150_200": null,
		"Fib_strlength_200_400": null,
		"Fib_strlength_400_600": null,
		"Fib_strlength_600_1000": null,
		"Fib_strlength_gt_1000": null,
		"Fib_strlength_200_300": null,
		"Fib_strlength_300_400": null,
		"Fib_strlength_400_500": null,
		"Fib_strlength_500_600": null,
		"Fib_strlength_600_700": null,
		"Fib_strlength_700_800": null,
		"Fib_strlength_800_900": null,
		"Fib_strlength_900_1000": null,
		"Fib_strlength_1000_1500": null,
		"Fib_strlength_1500_2000": null,
		"Fib_strlength_2000_2500": null,
		"Fib_strlength_2500_3000": null,
		"Fib_strlength_gt_3000": null,
		"analysis_int": 128005,
		"Passed": "0",
		"zeichnr": "Schiene",
		"met_sum": 3.0,
		"nm_sum": 998.0,
		"sum_fibers": 149.0,
		"fibers_sum": 149.0,
		"smallest_size_class": "50-100",
		"ioResult": true,
		"zeichindex": "1234"
	},
	{
		"artsuch": "Schiene",
		"betaufnr": 128006,
		"kdnr": 12346,
		"artnr": "5123437",
		"Analysis_No": "128006",
		"Parts_on_Filter": 6.0,
		"Component_Surface_Area_cm2": 186.0,
		"Weight_mg": 0.48,
		"Date_of_arrival": "2021-08-06T15:00:00",
		"Date_of_Extraction": "2021-08-06T15:00:00",
		"Date_of_Analysis": "2021-08-06T15:00:00",
		"Component": "Schiene",
		"Component_No": "XYZ",
		"Testing_Specification": "5123437",
		"customer_no": "12346",
		"Place_of_probe": "nicht bekannt / unknown",
		"Condition_of_delivery": "i. O.",
		"Extraction_Method": null,
		"Extraction_Liquid": null,
		"Amount_Liquid": null,
		"volume_flow": null,
		"nozzle_dimension": null,
		"amount_flushing": null,
		"extraction_equipment": null,
		"Filter_Type": null,
		"filter_diameter": "47 mm",
		"Comment": null,
		"Scale": "X:5,4 μm/Pxl   Y:5,4 μm/Pxl",
		"Evaluated_diameter_mm": 44.0,
		"occupancy": 0.745134,
		"Fiber_Compactness_Criterion": null,
		"Fiber_Length_Width_Criterion": null,
		"Fiber_Stret_InCircle_criterion": 10.0,
		"Fiber_max_InCircle_criterion": 50.0,
		"woF_5_15": 11763.0,
		"woF_15_25": 9086.0,
		"woF_25_50": 4304.0,
		"woF_50_100": 987.0,
		"woF_100_150": 140.0,
		"woF_150_200": 31.0,
		"woF_200_400": 24.0,
		"woF_400_600": 2.0,
		"woF_600_1000": 0.0,
		"woF_gt_1000": 0.0,
		"woF_200_300": 2.0,
		"woF_300_400": 0.0,
		"woF_400_500": null,
		"woF_500_600": 2.0,
		"woF_600_700": 0.0,
		"woF_700_800": 0.0,
		"woF_800_900": 0.0,
		"woF_900_1000": 0.0,
		"woF_1000_1500": 0.0,
		"woF_1500_2000": 0.0,
		"woF_2000_2500": 0.0,
		"woF_2500_3000": 0.0,
		"woF_gt_3000": 0.0,
		"All_5_15": 11763.0,
		"All_15_25": 9086.0,
		"All_25_50": 4304.0,
		"All_50_100": 1009.0,
		"All_100_150": 184.0,
		"All_150_200": 60.0,
		"All_200_400": 89.0,
		"All_400_600": 24.0,
		"All_600_1000": 15.0,
		"All_gt_1000": 14.0,
		"All_200_300": 53.0,
		"All_300_400": 29.0,
		"All_400_500": null,
		"All_500_600": 12.0,
		"All_600_700": 4.0,
		"All_700_800": 4.0,
		"All_800_900": 3.0,
		"All_900_1000": 4.0,
		"All_1000_1500": 10.0,
		"All_1500_2000": 2.0,
		"All_2000_2500": 2.0,
		"All_2500_3000": 0.0,
		"All_gt_3000": 0.0,
		"Met_5_15": 2.0,
		"Met_15_25": 2.0,
		"Met_25_50": 0.0,
		"Met_50_100": 1.0,
		"Met_100_150": 2.0,
		"Met_150_200": 1.0,
		"Met_200_400": 1.0,
		"Met_400_600": 0.0,
		"Met_600_1000": 0.0,
		"Met_gt_1000": 0.0,
		"Met_200_300": 0.0,
		"Met_300_400": 0.0,
		"Met_400_500": null,
		"Met_500_600": 0.0,
		"Met_600_700": 0.0,
		"Met_700_800": 0.0,
		"Met_800_900": 0.0,
		"Met_900_1000": 0.0,
		"Met_1000_1500": 0.0,
		"Met_1500_2000": 0.0,
		"Met_2000_2500": 0.0,
		"Met_2500_3000": 0.0,
		"Met_gt_3000": 0.0,
		"woFNM_1L": 567.0,
		"woFNM_1W": 405.0,
		"woFNM_2L": 557.0,
		"woFNM_2W": 384.0,
		"woFNM_3L": 369.0,
		"woFNM_3W": 107.0,
		"woFNM_4L": 336.0,
		"woFNM_4W": 192.0,
		"woFNM_5L": 319.0,
		"woFNM_5W": 222.0,
		"Met_1L": 230.0,
		"Met_1W": 157.0,
		"Met_2L": 169.0,
		"Met_2W": 84.0,
		"Met_3L": 116.0,
		"Met_3W": 85.0,
		"Met_4L": 102.0,
		"Met_4W": 74.0,
		"Met_5L": 58.0,
		"Met_5W": 48.0,
		"Fib_Fmax1_Fmax": 2333.0,
		"Fib_Fmax1_Lstr": 2734.0,
		"Fib_Fmax2_Fmax": 2115.0,
		"Fib_Fmax2_Lstr": 2493.0,
		"Fib_Lstr1_Fmax": 2333.0,
		"Fib_Lstr1_Lstr": 2734.0,
		"Fib_Fmax_Sum_um": 74067.0,
		"Fib_Stretched_Sum_um": 87001.0,
		"woF_weighted_sum": 2338.0,
		"All_weighted_sum": 13005.0,
		"Met_weighted_sum": 34.0,
		"Fib_strlength_5_15": null,
		"Fib_strlength_15_25": null,
		"Fib_strlength_25_50": null,
		"Fib_strlength_50_100": null,
		"Fib_strlength_100_150": null,
		"Fib_strlength_150_200": null,
		"Fib_strlength_200_400": null,
		"Fib_strlength_400_600": null,
		"Fib_strlength_600_1000": null,
		"Fib_strlength_gt_1000": null,
		"Fib_strlength_200_300": null,
		"Fib_strlength_300_400": null,
		"Fib_strlength_400_500": null,
		"Fib_strlength_500_600": null,
		"Fib_strlength_600_700": null,
		"Fib_strlength_700_800": null,
		"Fib_strlength_800_900": null,
		"Fib_strlength_900_1000": null,
		"Fib_strlength_1000_1500": null,
		"Fib_strlength_1500_2000": null,
		"Fib_strlength_2000_2500": null,
		"Fib_strlength_2500_3000": null,
		"Fib_strlength_gt_3000": null,
		"analysis_int": 128006,
		"Passed": "1",
		"zeichnr": "Schiene",
		"met_sum": 5.0,
		"nm_sum": 1179.0,
		"sum_fibers": 209.0,
		"fibers_sum": 209.0,
		"smallest_size_class": "50-100",
		"ioResult": true,
		"zeichindex": "1234"
	},
	{
		"artsuch": "Schiene",
		"betaufnr": 128007,
		"kdnr": 12346,
		"artnr": "5123437",
		"Analysis_No": "128007",
		"Parts_on_Filter": 6.0,
		"Component_Surface_Area_cm2": 186.0,
		"Weight_mg": 0.41,
		"Date_of_arrival": "2021-08-07T15:00:00",
		"Date_of_Extraction": "2021-08-07T15:00:00",
		"Date_of_Analysis": "2021-08-07T15:00:00",
		"Component": "Schiene",
		"Component_No": "XYZ",
		"Testing_Specification": "5123437",
		"customer_no": "12346",
		"Place_of_probe": "nicht bekannt / unknown",
		"Condition_of_delivery": "i. O.",
		"Extraction_Method": null,
		"Extraction_Liquid": null,
		"Amount_Liquid": null,
		"volume_flow": null,
		"nozzle_dimension": null,
		"amount_flushing": null,
		"extraction_equipment": null,
		"Filter_Type": null,
		"filter_diameter": "47 mm",
		"Comment": null,
		"Scale": "X:5,4 μm/Pxl   Y:5,4 μm/Pxl",
		"Evaluated_diameter_mm": 44.0,
		"occupancy": 0.724435,
		"Fiber_Compactness_Criterion": null,
		"Fiber_Length_Width_Criterion": null,
		"Fiber_Stret_InCircle_criterion": 10.0,
		"Fiber_max_InCircle_criterion": 50.0,
		"woF_5_15": 11346.0,
		"woF_15_25": 7477.0,
		"woF_25_50": 3562.0,
		"woF_50_100": 818.0,
		"woF_100_150": 95.0,
		"woF_150_200": 38.0,
		"woF_200_400": 24.0,
		"woF_400_600": 6.0,
		"woF_600_1000": 2.0,
		"woF_gt_1000": 1.0,
		"woF_200_300": 9.0,
		"woF_300_400": 3.0,
		"woF_400_500": null,
		"woF_500_600": 3.0,
		"woF_600_700": 2.0,
		"woF_700_800": 0.0,
		"woF_800_900": 0.0,
		"woF_900_1000": 0.0,
		"woF_1000_1500": 0.0,
		"woF_1500_2000": 0.0,
		"woF_2000_2500": 0.0,
		"woF_2500_3000": 1.0,
		"woF_gt_3000": 0.0,
		"All_5_15": 11346.0,
		"All_15_25": 7477.0,
		"All_25_50": 3562.0,
		"All_50_100": 835.0,
		"All_100_150": 132.0,
		"All_150_200": 78.0,
		"All_200_400": 68.0,
		"All_400_600": 25.0,
		"All_600_1000": 14.0,
		"All_gt_1000": 12.0,
		"All_200_300": 51.0,
		"All_300_400": 26.0,
		"All_400_500": null,
		"All_500_600": 13.0,
		"All_600_700": 4.0,
		"All_700_800": 5.0,
		"All_800_900": 2.0,
		"All_900_1000": 3.0,
		"All_1000_1500": 5.0,
		"All_1500_2000": 4.0,
		"All_2000_2500": 1.0,
		"All_2500_3000": 1.0,
		"All_gt_3000": 1.0,
		"Met_5_15": 4.0,
		"Met_15_25": 7.0,
		"Met_25_50": 6.0,
		"Met_50_100": 4.0,
		"Met_100_150": 0.0,
		"Met_150_200": 1.0,
		"Met_200_400": 0.0,
		"Met_400_600": 0.0,
		"Met_600_1000": 0.0,
		"Met_gt_1000": 0.0,
		"Met_200_300": 0.0,
		"Met_300_400": 0.0,
		"Met_400_500": null,
		"Met_500_600": 0.0,
		"Met_600_700": 0.0,
		"Met_700_800": 0.0,
		"Met_800_900": 0.0,
		"Met_900_1000": 0.0,
		"Met_1000_1500": 0.0,
		"Met_1500_2000": 0.0,
		"Met_2000_2500": 0.0,
		"Met_2500_3000": 0.0,
		"Met_gt_3000": 0.0,
		"woFNM_1L": 2992.0,
		"woFNM_1W": 1472.0,
		"woFNM_2L": 697.0,
		"woFNM_2W": 492.0,
		"woFNM_3L": 683.0,
		"woFNM_3W": 109.0,
		"woFNM_4L": 578.0,
		"woFNM_4W": 428.0,
		"woFNM_5L": 575.0,
		"woFNM_5W": 197.0,
		"Met_1L": 150.0,
		"Met_1W": 80.0,
		"Met_2L": 68.0,
		"Met_2W": 44.0,
		"Met_3L": 61.0,
		"Met_3W": 27.0,
		"Met_4L": 56.0,
		"Met_4W": 22.0,
		"Met_5L": 56.0,
		"Met_5W": 38.0,
		"Fib_Fmax1_Fmax": 4067.0,
		"Fib_Fmax1_Lstr": 5758.0,
		"Fib_Fmax2_Fmax": 2290.0,
		"Fib_Fmax2_Lstr": 2555.0,
		"Fib_Lstr1_Fmax": 4067.0,
		"Fib_Lstr1_Lstr": 5758.0,
		"Fib_Fmax_Sum_um": 63678.0,
		"Fib_Stretched_Sum_um": 73883.0,
		"woF_weighted_sum": 2996.0,
		"All_weighted_sum": 11569.0,
		"Met_weighted_sum": 13.0,
		"Fib_strlength_5_15": null,
		"Fib_strlength_15_25": null,
		"Fib_strlength_25_50": null,
		"Fib_strlength_50_100": null,
		"Fib_strlength_100_150": null,
		"Fib_strlength_150_200": null,
		"Fib_strlength_200_400": null,
		"Fib_strlength_400_600": null,
		"Fib_strlength_600_1000": null,
		"Fib_strlength_gt_1000": null,
		"Fib_strlength_200_300": null,
		"Fib_strlength_300_400": null,
		"Fib_strlength_400_500": null,
		"Fib_strlength_500_600": null,
		"Fib_strlength_600_700": null,
		"Fib_strlength_700_800": null,
		"Fib_strlength_800_900": null,
		"Fib_strlength_900_1000": null,
		"Fib_strlength_1000_1500": null,
		"Fib_strlength_1500_2000": null,
		"Fib_strlength_2000_2500": null,
		"Fib_strlength_2500_3000": null,
		"Fib_strlength_gt_3000": null,
		"analysis_int": 128007,
		"Passed": "0",
		"zeichnr": "Schiene",
		"met_sum": 5.0,
		"nm_sum": 979.0,
		"sum_fibers": 179.0,
		"fibers_sum": 179.0,
		"smallest_size_class": "50-100",
		"ioResult": true,
		"zeichindex": "1234"
	},
	{
		"artsuch": "Schiene",
		"betaufnr": 128008,
		"kdnr": 12346,
		"artnr": "5123437",
		"Analysis_No": "128008",
		"Parts_on_Filter": 6.0,
		"Component_Surface_Area_cm2": 186.0,
		"Weight_mg": 0.44,
		"Date_of_arrival": "2021-08-08T15:00:00",
		"Date_of_Extraction": "2021-08-08T15:00:00",
		"Date_of_Analysis": "2021-08-08T15:00:00",
		"Component": "Schiene",
		"Component_No": "XYZ",
		"Testing_Specification": "5123437",
		"customer_no": "12346",
		"Place_of_probe": "nicht bekannt / unknown",
		"Condition_of_delivery": "i. O.",
		"Extraction_Method": null,
		"Extraction_Liquid": null,
		"Amount_Liquid": null,
		"volume_flow": null,
		"nozzle_dimension": null,
		"amount_flushing": null,
		"extraction_equipment": null,
		"Filter_Type": null,
		"filter_diameter": "47 mm",
		"Comment": null,
		"Scale": "X:5,4 μm/Pxl   Y:5,4 μm/Pxl",
		"Evaluated_diameter_mm": 44.0,
		"occupancy": 0.703095,
		"Fiber_Compactness_Criterion": null,
		"Fiber_Length_Width_Criterion": null,
		"Fiber_Stret_InCircle_criterion": 10.0,
		"Fiber_max_InCircle_criterion": 50.0,
		"woF_5_15": 11670.0,
		"woF_15_25": 8684.0,
		"woF_25_50": 3768.0,
		"woF_50_100": 786.0,
		"woF_100_150": 88.0,
		"woF_150_200": 23.0,
		"woF_200_400": 24.0,
		"woF_400_600": 3.0,
		"woF_600_1000": 2.0,
		"woF_gt_1000": 1.0,
		"woF_200_300": 6.0,
		"woF_300_400": 3.0,
		"woF_400_500": null,
		"woF_500_600": 3.0,
		"woF_600_700": 0.0,
		"woF_700_800": 2.0,
		"woF_800_900": 0.0,
		"woF_900_1000": 0.0,
		"woF_1000_1500": 1.0,
		"woF_1500_2000": 0.0,
		"woF_2000_2500": 0.0,
		"woF_2500_3000": 0.0,
		"woF_gt_3000": 0.0,
		"All_5_15": 11670.0,
		"All_15_25": 8684.0,
		"All_25_50": 3768.0,
		"All_50_100": 804.0,
		"All_100_150": 116.0,
		"All_150_200": 45.0,
		"All_200_400": 69.0,
		"All_400_600": 21.0,
		"All_600_1000": 14.0,
		"All_gt_1000": 12.0,
		"All_200_300": 47.0,
		"All_300_400": 26.0,
		"All_400_500": null,
		"All_500_600": 16.0,
		"All_600_700": 5.0,
		"All_700_800": 6.0,
		"All_800_900": 3.0,
		"All_900_1000": 0.0,
		"All_1000_1500": 8.0,
		"All_1500_2000": 1.0,
		"All_2000_2500": 0.0,
		"All_2500_3000": 0.0,
		"All_gt_3000": 3.0,
		"Met_5_15": 1.0,
		"Met_15_25": 1.0,
		"Met_25_50": 4.0,
		"Met_50_100": 1.0,
		"Met_100_150": 5.0,
		"Met_150_200": 0.0,
		"Met_200_400": 0.0,
		"Met_400_600": 0.0,
		"Met_600_1000": 0.0,
		"Met_gt_1000": 1.0,
		"Met_200_300": 1.0,
		"Met_300_400": 1.0,
		"Met_400_500": null,
		"Met_500_600": 0.0,
		"Met_600_700": 0.0,
		"Met_700_800": 0.0,
		"Met_800_900": 0.0,
		"Met_900_1000": 0.0,
		"Met_1000_1500": 1.0,
		"Met_1500_2000": 0.0,
		"Met_2000_2500": 0.0,
		"Met_2500_3000": 0.0,
		"Met_gt_3000": 0.0,
		"woFNM_1L": 750.0,
		"woFNM_1W": 254.0,
		"woFNM_2L": 736.0,
		"woFNM_2W": 286.0,
		"woFNM_3L": 587.0,
		"woFNM_3W": 60.0,
		"woFNM_4L": 581.0,
		"woFNM_4W": 416.0,
		"woFNM_5L": 550.0,
		"woFNM_5W": 330.0,
		"Met_1L": 1144.0,
		"Met_1W": 243.0,
		"Met_2L": 142.0,
		"Met_2W": 65.0,
		"Met_3L": 129.0,
		"Met_3W": 59.0,
		"Met_4L": 123.0,
		"Met_4W": 73.0,
		"Met_5L": 117.0,
		"Met_5W": 89.0,
		"Fib_Fmax1_Fmax": 4245.0,
		"Fib_Fmax1_Lstr": 5387.0,
		"Fib_Fmax2_Fmax": 3855.0,
		"Fib_Fmax2_Lstr": 10585.0,
		"Fib_Lstr1_Fmax": 3855.0,
		"Fib_Lstr1_Lstr": 10585.0,
		"Fib_Fmax_Sum_um": 61264.0,
		"Fib_Stretched_Sum_um": 78773.0,
		"woF_weighted_sum": 2609.0,
		"All_weighted_sum": 10937.0,
		"Met_weighted_sum": 421.0,
		"Fib_strlength_5_15": null,
		"Fib_strlength_15_25": null,
		"Fib_strlength_25_50": null,
		"Fib_strlength_50_100": null,
		"Fib_strlength_100_150": null,
		"Fib_strlength_150_200": null,
		"Fib_strlength_200_400": null,
		"Fib_strlength_400_600": null,
		"Fib_strlength_600_1000": null,
		"Fib_strlength_gt_1000": null,
		"Fib_strlength_200_300": null,
		"Fib_strlength_300_400": null,
		"Fib_strlength_400_500": null,
		"Fib_strlength_500_600": null,
		"Fib_strlength_600_700": null,
		"Fib_strlength_700_800": null,
		"Fib_strlength_800_900": null,
		"Fib_strlength_900_1000": null,
		"Fib_strlength_1000_1500": null,
		"Fib_strlength_1500_2000": null,
		"Fib_strlength_2000_2500": null,
		"Fib_strlength_2500_3000": null,
		"Fib_strlength_gt_3000": null,
		"analysis_int": 128008,
		"Passed": "0",
		"zeichnr": "Schiene",
		"met_sum": 7.0,
		"nm_sum": 920.0,
		"sum_fibers": 154.0,
		"fibers_sum": 154.0,
		"smallest_size_class": "50-100",
		"ioResult": true,
		"zeichindex": "1234"
	},
	{
		"artsuch": "Schiene",
		"betaufnr": 128009,
		"kdnr": 12346,
		"artnr": "5123437",
		"Analysis_No": "128009",
		"Parts_on_Filter": 6.0,
		"Component_Surface_Area_cm2": 186.0,
		"Weight_mg": 1.08,
		"Date_of_arrival": "2021-08-09T15:00:00",
		"Date_of_Extraction": "2021-08-09T15:00:00",
		"Date_of_Analysis": "2021-08-09T15:00:00",
		"Component": "Schiene",
		"Component_No": "XYZ",
		"Testing_Specification": "5123437",
		"customer_no": "12346",
		"Place_of_probe": "nicht bekannt / unknown",
		"Condition_of_delivery": "i. O.",
		"Extraction_Method": null,
		"Extraction_Liquid": null,
		"Amount_Liquid": null,
		"volume_flow": null,
		"nozzle_dimension": null,
		"amount_flushing": null,
		"extraction_equipment": null,
		"Filter_Type": null,
		"filter_diameter": "47 mm",
		"Comment": null,
		"Scale": "X:5,4 μm/Pxl   Y:5,4 μm/Pxl",
		"Evaluated_diameter_mm": 44.0,
		"occupancy": 0.471981,
		"Fiber_Compactness_Criterion": null,
		"Fiber_Length_Width_Criterion": null,
		"Fiber_Stret_InCircle_criterion": 10.0,
		"Fiber_max_InCircle_criterion": 50.0,
		"woF_5_15": 11513.0,
		"woF_15_25": 6705.0,
		"woF_25_50": 2126.0,
		"woF_50_100": 495.0,
		"woF_100_150": 78.0,
		"woF_150_200": 16.0,
		"woF_200_400": 14.0,
		"woF_400_600": 3.0,
		"woF_600_1000": 0.0,
		"woF_gt_1000": 0.0,
		"woF_200_300": 1.0,
		"woF_300_400": 0.0,
		"woF_400_500": null,
		"woF_500_600": 1.0,
		"woF_600_700": 0.0,
		"woF_700_800": 0.0,
		"woF_800_900": 0.0,
		"woF_900_1000": 0.0,
		"woF_1000_1500": 0.0,
		"woF_1500_2000": 0.0,
		"woF_2000_2500": 0.0,
		"woF_2500_3000": 0.0,
		"woF_gt_3000": 0.0,
		"All_5_15": 11513.0,
		"All_15_25": 6705.0,
		"All_25_50": 2126.0,
		"All_50_100": 513.0,
		"All_100_150": 122.0,
		"All_150_200": 55.0,
		"All_200_400": 69.0,
		"All_400_600": 17.0,
		"All_600_1000": 11.0,
		"All_gt_1000": 11.0,
		"All_200_300": 33.0,
		"All_300_400": 22.0,
		"All_400_500": null,
		"All_500_600": 6.0,
		"All_600_700": 2.0,
		"All_700_800": 3.0,
		"All_800_900": 1.0,
		"All_900_1000": 5.0,
		"All_1000_1500": 6.0,
		"All_1500_2000": 1.0,
		"All_2000_2500": 1.0,
		"All_2500_3000": 1.0,
		"All_gt_3000": 2.0,
		"Met_5_15": 3.0,
		"Met_15_25": 3.0,
		"Met_25_50": 2.0,
		"Met_50_100": 2.0,
		"Met_100_150": 1.0,
		"Met_150_200": 1.0,
		"Met_200_400": 0.0,
		"Met_400_600": 0.0,
		"Met_600_1000": 0.0,
		"Met_gt_1000": 0.0,
		"Met_200_300": 0.0,
		"Met_300_400": 0.0,
		"Met_400_500": null,
		"Met_500_600": 0.0,
		"Met_600_700": 0.0,
		"Met_700_800": 0.0,
		"Met_800_900": 0.0,
		"Met_900_1000": 0.0,
		"Met_1000_1500": 0.0,
		"Met_1500_2000": 0.0,
		"Met_2000_2500": 0.0,
		"Met_2500_3000": 0.0,
		"Met_gt_3000": 0.0,
		"woFNM_1L": 546.0,
		"woFNM_1W": 326.0,
		"woFNM_2L": 442.0,
		"woFNM_2W": 273.0,
		"woFNM_3L": 417.0,
		"woFNM_3W": 176.0,
		"woFNM_4L": 347.0,
		"woFNM_4W": 188.0,
		"woFNM_5L": 302.0,
		"woFNM_5W": 68.0,
		"Met_1L": 170.0,
		"Met_1W": 59.0,
		"Met_2L": 123.0,
		"Met_2W": 22.0,
		"Met_3L": 86.0,
		"Met_3W": 54.0,
		"Met_4L": 82.0,
		"Met_4W": 38.0,
		"Met_5L": 49.0,
		"Met_5W": 38.0,
		"Fib_Fmax1_Fmax": 6245.0,
		"Fib_Fmax1_Lstr": 7882.0,
		"Fib_Fmax2_Fmax": 3151.0,
		"Fib_Fmax2_Lstr": 3581.0,
		"Fib_Lstr1_Fmax": 6245.0,
		"Fib_Lstr1_Lstr": 7882.0,
		"Fib_Fmax_Sum_um": 68379.0,
		"Fib_Stretched_Sum_um": 77303.0,
		"woF_weighted_sum": 1367.0,
		"All_weighted_sum": 9672.0,
		"Met_weighted_sum": 15.0,
		"Fib_strlength_5_15": null,
		"Fib_strlength_15_25": null,
		"Fib_strlength_25_50": null,
		"Fib_strlength_50_100": null,
		"Fib_strlength_100_150": null,
		"Fib_strlength_150_200": null,
		"Fib_strlength_200_400": null,
		"Fib_strlength_400_600": null,
		"Fib_strlength_600_1000": null,
		"Fib_strlength_gt_1000": null,
		"Fib_strlength_200_300": null,
		"Fib_strlength_300_400": null,
		"Fib_strlength_400_500": null,
		"Fib_strlength_500_600": null,
		"Fib_strlength_600_700": null,
		"Fib_strlength_700_800": null,
		"Fib_strlength_800_900": null,
		"Fib_strlength_900_1000": null,
		"Fib_strlength_1000_1500": null,
		"Fib_strlength_1500_2000": null,
		"Fib_strlength_2000_2500": null,
		"Fib_strlength_2500_3000": null,
		"Fib_strlength_gt_3000": null,
		"analysis_int": 128009,
		"Passed": null,
		"zeichnr": "Schiene",
		"met_sum": 4.0,
		"nm_sum": 602.0,
		"sum_fibers": 191.0,
		"fibers_sum": 191.0,
		"smallest_size_class": "50-100",
		"ioResult": true,
		"zeichindex": "1234"
	},
	{
		"artsuch": "Schiene",
		"betaufnr": 128010,
		"kdnr": 12346,
		"artnr": "5123437",
		"Analysis_No": "128010",
		"Parts_on_Filter": 6.0,
		"Component_Surface_Area_cm2": 186.0,
		"Weight_mg": 0.65,
		"Date_of_arrival": "2021-08-10T15:00:00",
		"Date_of_Extraction": "2021-08-10T15:00:00",
		"Date_of_Analysis": "2021-08-10T15:00:00",
		"Component": "Schiene",
		"Component_No": "XYZ",
		"Testing_Specification": "5123437",
		"customer_no": "12346",
		"Place_of_probe": "nicht bekannt / unknown",
		"Condition_of_delivery": "i. O.",
		"Extraction_Method": null,
		"Extraction_Liquid": null,
		"Amount_Liquid": null,
		"volume_flow": null,
		"nozzle_dimension": null,
		"amount_flushing": null,
		"extraction_equipment": null,
		"Filter_Type": null,
		"filter_diameter": "47 mm",
		"Comment": null,
		"Scale": "X:5,4 μm/Pxl   Y:5,4 μm/Pxl",
		"Evaluated_diameter_mm": 44.0,
		"occupancy": 0.359861,
		"Fiber_Compactness_Criterion": null,
		"Fiber_Length_Width_Criterion": null,
		"Fiber_Stret_InCircle_criterion": 10.0,
		"Fiber_max_InCircle_criterion": 50.0,
		"woF_5_15": 8234.0,
		"woF_15_25": 4242.0,
		"woF_25_50": 1641.0,
		"woF_50_100": 518.0,
		"woF_100_150": 95.0,
		"woF_150_200": 16.0,
		"woF_200_400": 10.0,
		"woF_400_600": 0.0,
		"woF_600_1000": 0.0,
		"woF_gt_1000": 0.0,
		"woF_200_300": 0.0,
		"woF_300_400": 0.0,
		"woF_400_500": null,
		"woF_500_600": 0.0,
		"woF_600_700": 0.0,
		"woF_700_800": 0.0,
		"woF_800_900": 0.0,
		"woF_900_1000": 0.0,
		"woF_1000_1500": 0.0,
		"woF_1500_2000": 0.0,
		"woF_2000_2500": 0.0,
		"woF_2500_3000": 0.0,
		"woF_gt_3000": 0.0,
		"All_5_15": 8234.0,
		"All_15_25": 4242.0,
		"All_25_50": 1641.0,
		"All_50_100": 528.0,
		"All_100_150": 116.0,
		"All_150_200": 36.0,
		"All_200_400": 51.0,
		"All_400_600": 6.0,
		"All_600_1000": 11.0,
		"All_gt_1000": 8.0,
		"All_200_300": 24.0,
		"All_300_400": 19.0,
		"All_400_500": null,
		"All_500_600": 3.0,
		"All_600_700": 3.0,
		"All_700_800": 4.0,
		"All_800_900": 3.0,
		"All_900_1000": 1.0,
		"All_1000_1500": 5.0,
		"All_1500_2000": 3.0,
		"All_2000_2500": 0.0,
		"All_2500_3000": 0.0,
		"All_gt_3000": 0.0,
		"Met_5_15": 1.0,
		"Met_15_25": 3.0,
		"Met_25_50": 0.0,
		"Met_50_100": 2.0,
		"Met_100_150": 0.0,
		"Met_150_200": 0.0,
		"Met_200_400": 0.0,
		"Met_400_600": 0.0,
		"Met_600_1000": 0.0,
		"Met_gt_1000": 0.0,
		"Met_200_300": 0.0,
		"Met_300_400": 0.0,
		"Met_400_500": null,
		"Met_500_600": 0.0,
		"Met_600_700": 0.0,
		"Met_700_800": 0.0,
		"Met_800_900": 0.0,
		"Met_900_1000": 0.0,
		"Met_1000_1500": 0.0,
		"Met_1500_2000": 0.0,
		"Met_2000_2500": 0.0,
		"Met_2500_3000": 0.0,
		"Met_gt_3000": 0.0,
		"woFNM_1L": 320.0,
		"woFNM_1W": 227.0,
		"woFNM_2L": 312.0,
		"woFNM_2W": 151.0,
		"woFNM_3L": 283.0,
		"woFNM_3W": 92.0,
		"woFNM_4L": 246.0,
		"woFNM_4W": 105.0,
		"woFNM_5L": 226.0,
		"woFNM_5W": 65.0,
		"Met_1L": 83.0,
		"Met_1W": 43.0,
		"Met_2L": 81.0,
		"Met_2W": 59.0,
		"Met_3L": 20.0,
		"Met_3W": 15.0,
		"Met_4L": 17.0,
		"Met_4W": 15.0,
		"Met_5L": 15.0,
		"Met_5W": 11.0,
		"Fib_Fmax1_Fmax": 1848.0,
		"Fib_Fmax1_Lstr": 3540.0,
		"Fib_Fmax2_Fmax": 1840.0,
		"Fib_Fmax2_Lstr": 2059.0,
		"Fib_Lstr1_Fmax": 1448.0,
		"Fib_Lstr1_Lstr": 3897.0,
		"Fib_Fmax_Sum_um": 41332.0,
		"Fib_Stretched_Sum_um": 52234.0,
		"woF_weighted_sum": 1202.0,
		"All_weighted_sum": 7300.0,
		"Met_weighted_sum": 2.0,
		"Fib_strlength_5_15": null,
		"Fib_strlength_15_25": null,
		"Fib_strlength_25_50": null,
		"Fib_strlength_50_100": null,
		"Fib_strlength_100_150": null,
		"Fib_strlength_150_200": null,
		"Fib_strlength_200_400": null,
		"Fib_strlength_400_600": null,
		"Fib_strlength_600_1000": null,
		"Fib_strlength_gt_1000": null,
		"Fib_strlength_200_300": null,
		"Fib_strlength_300_400": null,
		"Fib_strlength_400_500": null,
		"Fib_strlength_500_600": null,
		"Fib_strlength_600_700": null,
		"Fib_strlength_700_800": null,
		"Fib_strlength_800_900": null,
		"Fib_strlength_900_1000": null,
		"Fib_strlength_1000_1500": null,
		"Fib_strlength_1500_2000": null,
		"Fib_strlength_2000_2500": null,
		"Fib_strlength_2500_3000": null,
		"Fib_strlength_gt_3000": null,
		"analysis_int": 128010,
		"Passed": null,
		"zeichnr": "Schiene",
		"met_sum": 2.0,
		"nm_sum": 637.0,
		"sum_fibers": 117.0,
		"fibers_sum": 117.0,
		"smallest_size_class": "50-100",
		"ioResult": true,
		"zeichindex": "1234"
	}
]
